import { Component, OnInit } from '@angular/core';
import { NotFoundService } from '../../core/services/404.service';

@Component({
    selector: 'app-web-layout',
    templateUrl: './web-layout.component.html',
    styleUrl: './web-layout.component.scss',
})
export class WebLayoutComponent implements OnInit {
    is404 = false;

    constructor(private notFoundService: NotFoundService) {}

    ngOnInit(): void {
        this.notFoundService.is404Active$.subscribe({
            next: (response) => {
                this.is404 = response;
            },
        });
    }
}
